export const columns = [
  {
    title: '患者姓名',
    dataIndex: 'patientName',
    width: 100,
    slots: { customRender: 'patientName' }
  },
  {
    title: '患者手机号码',
    dataIndex: 'patientPhone',
    width: 180,
    slots: { customRender: 'patientPhone' }
  },
  {
    title: '医生ID',
    dataIndex: 'doctorId',
    width: 100
  },
  {
    title: '医生姓名',
    dataIndex: 'doctorName',
    width: 100
  },
  {
    title: '医生手机号码',
    dataIndex: 'doctorPhone',
    width: 180,
    slots: { customRender: 'doctorPhone' }
  },
  {
    title: '绑定BD',
    dataIndex: 'bdName',
    width: 100
  },
  {
    title: 'BD手机号码',
    dataIndex: 'bdPhone',
    width: 180,
    slots: { customRender: 'bdPhone' }
  },
  {
    title: '注册时间',
    dataIndex: 'createAt',
    width: 220
  },
  {
    title: '操作',
    dataIndex: 'handler',
    width: 300,
    slots: { customRender: 'handler' },
    fixed: 'right'
  }
]
export const paginationConfig = {
  current: 1,
  pageSize: 10,
  showQuickJumper: true,
  showSizeChanger: true,
  total: 0,
  showTotal: () => {}
}
